// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/past_performance.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { LibraryItemView } from "./projectdata_pb";
/**
 * PastPerformanceReferenceDetailsView is the extension row. Empty string means
 * "unknown"; an unset timestamp means "unknown".
 *
 * @generated from message mono.projectdata.v1.PastPerformanceReferenceDetailsView
 */ export class PastPerformanceReferenceDetailsView extends Message {
    static fromBinary(bytes, options) {
        return new PastPerformanceReferenceDetailsView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PastPerformanceReferenceDetailsView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PastPerformanceReferenceDetailsView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PastPerformanceReferenceDetailsView, a, b);
    }
    constructor(data){
        super(), /**
   * internal|partner|historical
   *
   * @generated from field: string reference_origin = 1;
   */ _define_property(this, "referenceOrigin", ""), /**
   * @generated from field: string provider_role = 2;
   */ _define_property(this, "providerRole", ""), /**
   * @generated from field: string limitations = 3;
   */ _define_property(this, "limitations", ""), /**
   * customer_confirmation|partner_reply|archived_record|delivery_interview|
   * program_derivative|manual_note
   *
   * @generated from field: string basis_kind = 4;
   */ _define_property(this, "basisKind", ""), /**
   * @generated from field: string source_person = 5;
   */ _define_property(this, "sourcePerson", ""), /**
   * @generated from field: google.protobuf.Timestamp source_date = 6;
   */ _define_property(this, "sourceDate", void 0), /**
   * @generated from field: string contract_identifier = 7;
   */ _define_property(this, "contractIdentifier", ""), /**
   * @generated from field: google.protobuf.Timestamp period_of_performance_start = 8;
   */ _define_property(this, "periodOfPerformanceStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp period_of_performance_end = 9;
   */ _define_property(this, "periodOfPerformanceEnd", void 0), /**
   * @generated from field: string outcome = 10;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: string reference_contact = 11;
   */ _define_property(this, "referenceContact", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PastPerformanceReferenceDetailsView, "runtime", proto3);
_define_property(PastPerformanceReferenceDetailsView, "typeName", "mono.projectdata.v1.PastPerformanceReferenceDetailsView");
_define_property(PastPerformanceReferenceDetailsView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reference_origin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "provider_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "limitations",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "basis_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_person",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "contract_identifier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "period_of_performance_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "period_of_performance_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "reference_contact",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * PastPerformanceReferenceView carries only item and extension fields — never
 * Program finances, staffing, risks, deliverables or notes. Reading a
 * reference does not grant access to the Program it links to.
 *
 * @generated from message mono.projectdata.v1.PastPerformanceReferenceView
 */ export class PastPerformanceReferenceView extends Message {
    static fromBinary(bytes, options) {
        return new PastPerformanceReferenceView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PastPerformanceReferenceView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PastPerformanceReferenceView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PastPerformanceReferenceView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.LibraryItemView item = 1;
   */ _define_property(this, "item", void 0), /**
   * @generated from field: mono.projectdata.v1.PastPerformanceReferenceDetailsView details = 2;
   */ _define_property(this, "details", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PastPerformanceReferenceView, "runtime", proto3);
_define_property(PastPerformanceReferenceView, "typeName", "mono.projectdata.v1.PastPerformanceReferenceView");
_define_property(PastPerformanceReferenceView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: LibraryItemView
        },
        {
            no: 2,
            name: "details",
            kind: "message",
            T: PastPerformanceReferenceDetailsView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreatePastPerformanceReferenceRequest
 */ export class CreatePastPerformanceReferenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreatePastPerformanceReferenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePastPerformanceReferenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePastPerformanceReferenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePastPerformanceReferenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string summary = 2;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: string customer_agency_name = 3;
   */ _define_property(this, "customerAgencyName", ""), /**
   * Required when details.reference_origin is "partner".
   *
   * @generated from field: string provider_company_profile_id = 4;
   */ _define_property(this, "providerCompanyProfileId", ""), /**
   * @generated from field: string scope_context = 5;
   */ _define_property(this, "scopeContext", ""), /**
   * @generated from field: string capability_context = 6;
   */ _define_property(this, "capabilityContext", ""), /**
   * Optional Program link. When supplied, the creator must already be
   * permitted to read that Program; otherwise PermissionDenied.
   *
   * @generated from field: string owning_scope_object_type = 7;
   */ _define_property(this, "owningScopeObjectType", ""), /**
   * @generated from field: string owning_scope_object_id = 8;
   */ _define_property(this, "owningScopeObjectId", ""), /**
   * @generated from field: string prepared_content = 9;
   */ _define_property(this, "preparedContent", ""), /**
   * @generated from field: string prepared_content_format = 10;
   */ _define_property(this, "preparedContentFormat", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 11;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: mono.projectdata.v1.PastPerformanceReferenceDetailsView details = 12;
   */ _define_property(this, "details", void 0), /**
   * @generated from field: string user_id = 13;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 14;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePastPerformanceReferenceRequest, "runtime", proto3);
_define_property(CreatePastPerformanceReferenceRequest, "typeName", "mono.projectdata.v1.CreatePastPerformanceReferenceRequest");
_define_property(CreatePastPerformanceReferenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "customer_agency_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "provider_company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "scope_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "capability_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "owning_scope_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "owning_scope_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "prepared_content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "prepared_content_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "details",
            kind: "message",
            T: PastPerformanceReferenceDetailsView
        },
        {
            no: 13,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreatePastPerformanceReferenceResponse
 */ export class CreatePastPerformanceReferenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreatePastPerformanceReferenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePastPerformanceReferenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePastPerformanceReferenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePastPerformanceReferenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.PastPerformanceReferenceView reference = 1;
   */ _define_property(this, "reference", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePastPerformanceReferenceResponse, "runtime", proto3);
_define_property(CreatePastPerformanceReferenceResponse, "typeName", "mono.projectdata.v1.CreatePastPerformanceReferenceResponse");
_define_property(CreatePastPerformanceReferenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reference",
            kind: "message",
            T: PastPerformanceReferenceView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPastPerformanceReferenceRequest
 */ export class GetPastPerformanceReferenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPastPerformanceReferenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPastPerformanceReferenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPastPerformanceReferenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPastPerformanceReferenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string library_item_id = 1;
   */ _define_property(this, "libraryItemId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPastPerformanceReferenceRequest, "runtime", proto3);
_define_property(GetPastPerformanceReferenceRequest, "typeName", "mono.projectdata.v1.GetPastPerformanceReferenceRequest");
_define_property(GetPastPerformanceReferenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPastPerformanceReferenceResponse
 */ export class GetPastPerformanceReferenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPastPerformanceReferenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPastPerformanceReferenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPastPerformanceReferenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPastPerformanceReferenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.PastPerformanceReferenceView reference = 1;
   */ _define_property(this, "reference", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPastPerformanceReferenceResponse, "runtime", proto3);
_define_property(GetPastPerformanceReferenceResponse, "typeName", "mono.projectdata.v1.GetPastPerformanceReferenceResponse");
_define_property(GetPastPerformanceReferenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reference",
            kind: "message",
            T: PastPerformanceReferenceView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListPastPerformanceReferencesRequest
 */ export class ListPastPerformanceReferencesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPastPerformanceReferencesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPastPerformanceReferencesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPastPerformanceReferencesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPastPerformanceReferencesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * optional filter
   *
   * @generated from field: string reference_origin = 1;
   */ _define_property(this, "referenceOrigin", ""), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPastPerformanceReferencesRequest, "runtime", proto3);
_define_property(ListPastPerformanceReferencesRequest, "typeName", "mono.projectdata.v1.ListPastPerformanceReferencesRequest");
_define_property(ListPastPerformanceReferencesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reference_origin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListPastPerformanceReferencesResponse
 */ export class ListPastPerformanceReferencesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPastPerformanceReferencesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPastPerformanceReferencesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPastPerformanceReferencesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPastPerformanceReferencesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.PastPerformanceReferenceView references = 1;
   */ _define_property(this, "references", []), /**
   * Count of rows actually permitted and returned to THIS viewer, never
   * pangaea's DB-predicate count.
   *
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPastPerformanceReferencesResponse, "runtime", proto3);
_define_property(ListPastPerformanceReferencesResponse, "typeName", "mono.projectdata.v1.ListPastPerformanceReferencesResponse");
_define_property(ListPastPerformanceReferencesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "references",
            kind: "message",
            T: PastPerformanceReferenceView,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
